import { AfterViewInit, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { config } from '../../../../config/config';
import { BaseComponent } from '../../../common/components/base.component';
import { popupCenter } from '../../../common/extensions/browser/browser.extensions';
import { HubEvent } from '../../../models/hub/hub.event';
import { HubPlace } from '../../../models/hub/hub.place';
import { ShareService } from '../../../services/share.service';
import ShareDialogParams = facebook.ShareDialogParams;

@Component({
  selector: 'ig-social-share',
  templateUrl: './social.share.component.html',
  styleUrls: ['./social.share.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SocialShareComponent extends BaseComponent {
  @Input() public item: HubEvent | HubPlace;
  @Input() public appearance = 'normal'; // normal | white | rounded
  @Input() public showTip = true;
  public link = '';
  public type = null;
  @Output() onShareToFB: EventEmitter<any> = new EventEmitter();
  @Output() onShareToTweet: EventEmitter<any> = new EventEmitter();
  @Output() onShareEmail: EventEmitter<any> = new EventEmitter();

  constructor() {
    super();
  }

  ngAfterContentInit() {
    this.setItemInfo();
  }

  public onKeyPress($event, social) {
    if ($event && $event.key === 'Enter') {
      if (social === 'facebook') {
        this.shareToFacebook();
      } else if (social === 'tweet') {
        this.tweetEvent();
      } else if (social === 'email') {
        this.mailEvent();
      }
    }
  }

  public shareToFacebook() {
    this.setItemInfo();

    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' + this.link,
      'facebook-share-dialog',
      'width=800,height=600'
    );

    // let params = <ShareDialogParams>{
    //   method: 'share',
    //   href: this.link,
    //   // quote: (this.item.title || this.item.name) + ' - ' + (this.item.description || (this.item as any).about || '(No description)'),
    //   quote: this.item.title || this.item.name,
    //   picture: this.item.cover ? this.item.cover.source : null,
    // };
    // FB.ui(params, () => {});

    this.onShareToFB.emit();
  }

  public tweetEvent() {
    this.setItemInfo();
    let shareLink = config.eventShare.tweet
      .replace('${text}', this.item.name)
      .replace('${url}', encodeURIComponent(this.link));
    popupCenter(shareLink);

    this.onShareToTweet.emit();
  }

  public mailEvent() {
    this.setItemInfo();
    let content = this.item.startTime
      ? ShareService.toMailableEvent(this.item.hubName, this.item, this.link)
      : ShareService.toMailablePlace(this.item.hubName, this.item, this.link);
    if (this.isMobile) {
      window.open(content);
    } else {
      window.location.href = content;
    }

    this.onShareEmail.emit();
  }

  private setItemInfo() {
    setTimeout(() => {
      this.type = this.item.startTime ? 'event' : 'place';
      this.link = this.item.startTime
        ? this.item.eventLink
        : this.item.hostLink || (this.item as HubPlace).hostGoogleLink || this.item.hostFacebookLink;
      this.link = this.link || window.location.href;
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/social.share/social.share.component.ts